import firebase from 'firebase'
import { useRef, useEffect } from 'react'
import { dateFnsLocales } from '../i18n'
import { format, addSeconds, getTime, startOfDay } from 'date-fns'

export function toggleFavoriteItem(
    savedFavorites,
    setFavorites,
    removeFavorites,
    id
) {
    const valueCloned = savedFavorites ? JSON.parse(savedFavorites) : []
    if (valueCloned.includes(id)) {
        const index = valueCloned.indexOf(id)
        if (index > -1) valueCloned.splice(index, 1)
    } else {
        valueCloned.push(id)
    }
    valueCloned.length > 0
        ? setFavorites(JSON.stringify(valueCloned))
        : removeFavorites()
}

export async function getFileUrl(path, name) {
    try {
        return await firebase.storage().ref(path).child(name).getDownloadURL()
    } catch (error) {
        console.log('Error while retrieving image', error)
    }
}

// If an item exist in array passed then the new item will be added, otherwise it will be removed
export function toggleFavoriteItemProfile(savedFavorites, newFavoriteId) {
    const savedFavoritesCloned = [...savedFavorites] || []
    if (savedFavoritesCloned.includes(newFavoriteId)) {
        const index = savedFavoritesCloned.indexOf(newFavoriteId)
        if (index > -1) savedFavoritesCloned.splice(index, 1)
    } else {
        savedFavoritesCloned.push(newFavoriteId)
    }

    return savedFavoritesCloned
}

export function usePrevious(value) {
    const ref = useRef()
    useEffect(() => {
        ref.current = value
    })
    return ref.current
}

export async function verifyPasswordResetCode(code) {
    return await firebase.auth().verifyPasswordResetCode(code)
}

export async function confirmPasswordReset(code, newPassword) {
    return await firebase.auth().confirmPasswordReset(code, newPassword)
}

export function arraysEqual(_arr1, _arr2) {
    if (
        !Array.isArray(_arr1) ||
        !Array.isArray(_arr2) ||
        _arr1.length !== _arr2.length
    )
        return false

    var arr1 = _arr1.concat().sort()
    var arr2 = _arr2.concat().sort()

    for (var i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) return false
    }

    return true
}

export function getDateFromSeconds(val, choosedFormat) {
    let date = addSeconds(new Date(0), val)
    date = format(date, choosedFormat, {
        locale: dateFnsLocales['it']['default'],
    })
    return date
}

export function getDateFromMinutes(val, choosedFormat) {
    return format(
        val * 60000 + getTime(startOfDay(new Date())),
        choosedFormat,
        {
            locale: dateFnsLocales['it']['default'],
        }
    )
}

export function debounced(delay, fn) {
    let timerId
    return (...args) => {
        if (timerId) {
            clearTimeout(timerId)
        }
        timerId = setTimeout(() => {
            fn(...args)
            timerId = null
        }, delay)
    }
}
